export const JOBS_RELOAD_TIME = 30000;
export const DATE_TIME_FORMAT = 'Do MMMM, YYYY : h:mm a';